<template>
  <div
    class="donation-form"
    :aria-busy="Object.keys(candidate).length === 0 ? 'true' : 'false'"
    :data-busy-message="dataBusyMessage"
  >
    <h2 v-if="!allowedPaymentMethods.length">
      {{ 'disabledDonations' | translate }}
    </h2>
    <template v-else-if="paymentStep === 'selectValue'">
      <h2>{{ 'donationPanel' | translate }}</h2>
      <selectValue />
    </template>
    <template v-else-if="paymentStep === 'finalMessage'">
      <finalMessage />
    </template>
    <template v-else>
      <userData v-if="paymentStep === 'userData'" />
      <addressData v-if="paymentStep === 'boleto'" />
      <certFaceVerify v-if="paymentStep === 'certFaceVerify'" />
      <printBoleto
        v-if="paymentStep === 'printBoleto'"
        :aria-busy="loading ? 'true' : 'false'"
      />
      <cardData v-if="paymentStep === 'cardData'" />

      <a
        v-if="certifaceError"
        class="donation-nav donation-nav--block"
        :href="'/'+ candidate.username +'#doar'"
      >
        Tentar Novamente
      </a>
    </template>
  </div>
</template>

<script>
import selectValue from './steps/selectValue.vue';
import userData from './steps/userData.vue';
import cardData from './steps/cardData.vue';
import finalMessage from './steps/finalMessage.vue';
import addressData from "./steps/addressData.vue";
import certFaceVerify from "./steps/certFaceVerify.vue";
import printBoleto from "./steps/printBoleto.vue";

export default {
  name: 'Payment',
  components: {
    selectValue,
    userData,
    addressData,
    certFaceVerify,
    cardData,
    finalMessage,
    printBoleto,
  },
  data(){
    return{
      loading: false,
      dataBusyMessage: '',
      certifaceError: false,
    }
  },
  computed: {
    paymentStep() {
      return this.$store.state.paymentStep;
    },
    amount() {
      return this.$store.state.amount;
    },
    candidate() {
      return this.getMergeCandidate.candidate;
    },
    getMergeCandidate() {
      return this.$store.getters.generateCandidateObject;
    },
    allowedPaymentMethods() {
      return (this.candidate || {}).allowed_payment_methods || ['credit_card', 'boleto'];
    }
  },
  mounted(){
    this.getCertiFaceQueryString();
    this.scrollToDonate();
  },
  methods: {
    scrollToDonate() {
      if(this.certifaceError) {
        const form = document.getElementById('doar');
        form.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    },
    toggleLoading(message = '') {
      this.loading = !this.loading;

      this.dataBusyMessage = this.dataBusyMessage !== message
        ? message
        : '';
    },
    getCertiFaceQueryString() {
      if(this.$route.query.donation_id){
        this.toggleLoading();

        this.$store.dispatch('CHANGE_PAYMENT_STEP', { step: 'printBoleto' });
        const payload = {
          donationId: this.$route.query.donation_id
        }
        this.$store.dispatch('START_DONATION_BOLETO', payload).then((response)=>{
          this.toggleLoading();
        },error => {
          this.toggleLoading();
          this.certifaceError = true;
          console.error(error)
        })
      }
    },
  },
};
</script>

<style>
.home__donate h2 {
  color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/Payment.vue